@if (label || tooltip) {
  <div class="form-field-label">
    @if (label) {
      <label class="primary-100 h4-bold">{{ label }}</label>
    }

    @if (tooltip) {
      <app-ce-icon
        class="primary-50"
        [name]="'help'"
        [svg_class]="['d-flex']"
        [matTooltip]="tooltip"
        [matTooltipPosition]="'right'"></app-ce-icon>
    }
  </div>
}

<div class="form-field-container">
  <div class="form-field-input">
    <div class="form-field-prefix"><ng-content select="[cePrefix]"></ng-content></div>
    <ng-content select="[ceInput]"></ng-content>
    <div class="form-field-suffix"><ng-content select="[ceSuffix]"></ng-content></div>
  </div>
  <ng-content></ng-content>
</div>
